import {TimelineTimeCoordinate, TimelineTimePoint, TimelineTimeSpan} from "./timelineTimeCoordinate.tsx";
import {format, isThisMonth, isToday} from "date-fns";
import {spawnTstzSpan} from "../tstzspan.ts";

export function formatTileTimelineCoordinate(tc: TimelineTimeCoordinate) {
    const atZrpc = TimelineTimePoint.safeParse(tc);
    const spanZrpc = TimelineTimeSpan.safeParse(tc);
    let rv;
    if (atZrpc.success) {
        const fmt = isToday(atZrpc.data.at)
            ? "HH:mm" : isThisMonth(atZrpc.data.at) ? "d日HH:mm" : "M月d日HH:mm";
        rv = format(atZrpc.data.at, fmt);
    } else if (spanZrpc.success && spanZrpc.data.span.lower) {
        const anchor = spanZrpc.data.span.lower;
        const liveSpan = spawnTstzSpan(spanZrpc.data.span);
        rv = liveSpan.asTimeIntervalString() ?? "??";
        if (!isToday(anchor)) {
            rv = format(anchor, isThisMonth(anchor) ? "d日" : "M月d日") + rv;
        }
    } else {
        throw new Error(`malformed time coordinate ${JSON.stringify(tc)}`);
    }
    return rv;
}